import React from "react";
import Teste from './teste';
import {logsAcessoQueries} from "../../graphql/LogsAcesso";
import { Query } from "react-apollo";
import MaterialTable from 'material-table';
import { Breadcrumbs, Modal, Paper, Typography, withStyles } from '@material-ui/core';
import { Button, Row, Col, ButtonToolbar, Form } from 'react-bootstrap';
import Environment from "../../environment/environment";

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
    },
});

class AdmLogsAcesso extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderGrid(data) {
        return (
            <MaterialTable
                columns={[
                    { title: "ID", field: "id" },
                    { title: "Data do evento", field: "created_at", defaultSort: 'desc', render: data => Environment.momentToLocalDateAndTimeString(data.created_at) },
                    { title: "Usuário", field: "usuario" },
                    { title: "Evento", field: "evento" },
                ]}
                data={data}
                localization={{
                    body: {
                        emptyDataSourceMessage: 'Nenhum registro encontrado.'
                    },
                    header: {},
                    toolbar: {
                        searchPlaceholder: 'Pesquisar',
                        searchTooltip: 'Pesquisar'
                    }
                }}
                options={{
                    actionsColumnIndex: -1,
                    paging: false,
                    draggable: false
                }}
                title={
                    "Logs de acesso"
                }
            />
        )
    }

    renderBreadCrumb() {
        return <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
            <Typography> Administrar </Typography>
            <div> Logs de acesso </div>
        </Breadcrumbs>;
    }

    render(){
        const { classes } = this.props;

        if(this.state.hasError)
            return (<div> Erro </div>);

        return (
            <Query query={logsAcessoQueries} >
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Carregando ...';
                    if (error) return `Error! ${error.message}`;

                    return (
                        <Paper className={classes.root}>
                            <Row>
                                <Col>
                                    {this.renderBreadCrumb()}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {this.renderGrid(data.listLogs)}
                                </Col>
                            </Row>
                        </Paper>
                    );
                }}
            </Query>
        );
    }

}

export default (withStyles(styles)(AdmLogsAcesso));